function addSimple(key, val, bonuses) {
	bonuses[key] = (bonuses[key] || 0) + val
}

function addKeyed(key, subKey, val, bonuses) {
	bonuses[key] = bonuses[key] || []
	bonuses[key][subKey] = (bonuses[key][subKey] || 0) + val
}

const OPTION_BONUS_MAP = {
	// Base stats
	VAR_STRAMOUNT: (v, b) => addSimple('bStr', v, b),
	VAR_AGIAMOUNT: (v, b) => addSimple('bAgi', v, b),
	VAR_VITAMOUNT: (v, b) => addSimple('bVit', v, b),
	VAR_INTAMOUNT: (v, b) => addSimple('bInt', v, b),
	VAR_DEXAMOUNT: (v, b) => addSimple('bDex', v, b),
	VAR_LUKAMOUNT: (v, b) => addSimple('bLuk', v, b),

	// Trait stats
	VAR_POWAMOUNT: (v, b) => addSimple('bPow', v, b),
	VAR_STAAMOUNT: (v, b) => addSimple('bSta', v, b),
	VAR_WISAMOUNT: (v, b) => addSimple('bWis', v, b),
	VAR_SPLAMOUNT: (v, b) => addSimple('bSpl', v, b),
	VAR_CONAMOUNT: (v, b) => addSimple('bCon', v, b),
	VAR_CRTAMOUNT: (v, b) => addSimple('bCrt', v, b),
	VAR_PATKAMOUNT: (v, b) => addSimple('bPAtk', v, b),
	VAR_SMATKAMOUNT: (v, b) => addSimple('bSMatk', v, b),
	VAR_RESAMOUNT: (v, b) => addSimple('bRes', v, b),
	VAR_MRESAMOUNT: (v, b) => addSimple('bMRes', v, b),

	// HP / SP
	VAR_MAXHPAMOUNT: (v, b) => addSimple('bMaxHP', v, b),
	VAR_MAXSPAMOUNT: (v, b) => addSimple('bMaxSP', v, b),
	VAR_MAXHPPERCENT: (v, b) => addSimple('bMaxHPrate', v, b),
	VAR_MAXSPPERCENT: (v, b) => addSimple('bMaxSPrate', v, b),
	VAR_HPACCELERATION: (v, b) => addSimple('bHPrecovRate', v, b),
	VAR_SPACCELERATION: (v, b) => addSimple('bSPrecovRate', v, b),

	// ATK / MATK
	VAR_ATTPOWER: (v, b) => addSimple('bBaseAtk', v, b),
	VAR_ATKPERCENT: (v, b) => addSimple('bAtkRate', v, b),
	VAR_ATTMPOWER: (v, b) => addSimple('bMatk', v, b),
	VAR_MAGICATKPERCENT: (v, b) => addSimple('bMatkRate', v, b),

	// DEF / MDEF
	VAR_ITEMDEFPOWER: (v, b) => addSimple('bDef', v, b),
	VAR_MDEFPOWER: (v, b) => addSimple('bMdef', v, b),

	// Secondary stats
	VAR_HITSUCCESSVALUE: (v, b) => addSimple('bHit', v, b),
	VAR_AVOIDSUCCESSVALUE: (v, b) => addSimple('bFlee', v, b),
	VAR_PLUSAVOIDSUCCESSVALUE: (v, b) => addSimple('bFlee2', v, b),
	VAR_CRITICALSUCCESSVALUE: (v, b) => addSimple('bCritical', v, b),
	VAR_CRITICAL_RATE: (v, b) => addSimple('bCRate', v, b),
	VAR_PLUSASPD: (v, b) => addSimple('bAspd', v, b),
	VAR_PLUSASPDPERCENT: (v, b) => addSimple('bAspdRate', v, b),

	// Heal
	VAR_HEAL_PLUS: (v, b) => addSimple('bHPlus', v, b),
	HEAL_VALUE: (v, b) => addSimple('bHPlus', v, b),
	HEAL_MODIFY_PERCENT: (v, b) => addSimple('bHealPower', v, b),

	// Critical damage
	DAMAGE_CRI_TARGET: (v, b) => addSimple('bCritAtkRate', v, b),

	// Cast time / delay / SP (reductions: stored as negative)
	DEC_SPELL_CAST_TIME: (v, b) => {
		b.bVariableCastrate = b.bVariableCastrate || []
		b.bVariableCastrate['All'] = (b.bVariableCastrate['All'] || 0) - v
	},
	DEC_SPELL_DELAY_TIME: (v, b) => addSimple('bDelayrate', -v, b),
	DEC_SP_CONSUMPTION: (v, b) => addSimple('bUseSPrate', -v, b),

	// Ranged / melee
	RANGE_ATTACK_DAMAGE_TARGET: (v, b) => addSimple('bLongAtkRate', v, b),
	RANGE_ATTACK_DAMAGE_USER: (v, b) => addSimple('bLongAtkDef', v, b),
	MELEE_ATTACK_DAMAGE_TARGET: (v, b) => addSimple('bShortAtkRate', v, b),

	// Size damage dealt
	DAMAGE_SIZE_LARGE_TARGET: (v, b) => addKeyed('bAddSize', 'Size_Large', v, b),
	DAMAGE_SIZE_MIDIUM_TARGET: (v, b) => addKeyed('bAddSize', 'Size_Medium', v, b),
	DAMAGE_SIZE_SMALL_TARGET: (v, b) => addKeyed('bAddSize', 'Size_Small', v, b),
	DAMAGE_SIZE_PERFECT: (v, b) => addSimple('bNoSizeFix', v, b),

	// Size damage received
	DAMAGE_SIZE_LARGE_USER: (v, b) => addKeyed('bSubSize', 'Size_Large', v, b),
	DAMAGE_SIZE_MIDIUM_USER: (v, b) => addKeyed('bSubSize', 'Size_Medium', v, b),
	DAMAGE_SIZE_SMALL_USER: (v, b) => addKeyed('bSubSize', 'Size_Small', v, b),

	// Weapon element
	WEAPON_ATTR_NOTHING: (_, b) => { b.bAtkEle = 'Ele_Neutral' },
	WEAPON_ATTR_WATER: (_, b) => { b.bAtkEle = 'Ele_Water' },
	WEAPON_ATTR_GROUND: (_, b) => { b.bAtkEle = 'Ele_Earth' },
	WEAPON_ATTR_FIRE: (_, b) => { b.bAtkEle = 'Ele_Fire' },
	WEAPON_ATTR_WIND: (_, b) => { b.bAtkEle = 'Ele_Wind' },
	WEAPON_ATTR_SAINT: (_, b) => { b.bAtkEle = 'Ele_Holy' },
	WEAPON_ATTR_DARKNESS: (_, b) => { b.bAtkEle = 'Ele_Dark' },

	// Body element
	BODY_ATTR_NOTHING: (_, b) => { b.bDefEle = 'Ele_Neutral' },
	BODY_ATTR_WATER: (_, b) => { b.bDefEle = 'Ele_Water' },
	BODY_ATTR_GROUND: (_, b) => { b.bDefEle = 'Ele_Earth' },
	BODY_ATTR_FIRE: (_, b) => { b.bDefEle = 'Ele_Fire' },
	BODY_ATTR_WIND: (_, b) => { b.bDefEle = 'Ele_Wind' },
	BODY_ATTR_SAINT: (_, b) => { b.bDefEle = 'Ele_Holy' },
	BODY_ATTR_DARKNESS: (_, b) => { b.bDefEle = 'Ele_Dark' },
	BODY_ATTR_POISON: (_, b) => { b.bDefEle = 'Ele_Poison' },
	BODY_ATTR_TELEKINESIS: (_, b) => { b.bDefEle = 'Ele_Ghost' },
	BODY_ATTR_UNDEAD: (_, b) => { b.bDefEle = 'Ele_Undead' },

	// Element tolerance (physical)
	ATTR_TOLERACE_NOTHING: (v, b) => addKeyed('bSubEle', 'Ele_Neutral', v, b),
	ATTR_TOLERACE_WATER: (v, b) => addKeyed('bSubEle', 'Ele_Water', v, b),
	ATTR_TOLERACE_GROUND: (v, b) => addKeyed('bSubEle', 'Ele_Earth', v, b),
	ATTR_TOLERACE_FIRE: (v, b) => addKeyed('bSubEle', 'Ele_Fire', v, b),
	ATTR_TOLERACE_WIND: (v, b) => addKeyed('bSubEle', 'Ele_Wind', v, b),
	ATTR_TOLERACE_POISON: (v, b) => addKeyed('bSubEle', 'Ele_Poison', v, b),
	ATTR_TOLERACE_SAINT: (v, b) => addKeyed('bSubEle', 'Ele_Holy', v, b),
	ATTR_TOLERACE_DARKNESS: (v, b) => addKeyed('bSubEle', 'Ele_Dark', v, b),
	ATTR_TOLERACE_TELEKINESIS: (v, b) => addKeyed('bSubEle', 'Ele_Ghost', v, b),
	ATTR_TOLERACE_UNDEAD: (v, b) => addKeyed('bSubEle', 'Ele_Undead', v, b),
	ATTR_TOLERACE_ALL: (v, b) => addKeyed('bSubEle', 'Ele_All', v, b),
	ATTR_TOLERACE_ALLBUTNOTHING: (v, b) => {
		;['Ele_Water', 'Ele_Earth', 'Ele_Fire', 'Ele_Wind', 'Ele_Poison', 'Ele_Holy', 'Ele_Dark', 'Ele_Ghost', 'Ele_Undead'].forEach(
			(e) => addKeyed('bSubEle', e, v, b),
		)
	},

	// Element damage dealt (physical)
	DAMAGE_PROPERTY_NOTHING_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Neutral', v, b),
	DAMAGE_PROPERTY_WATER_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Water', v, b),
	DAMAGE_PROPERTY_GROUND_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Earth', v, b),
	DAMAGE_PROPERTY_FIRE_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Fire', v, b),
	DAMAGE_PROPERTY_WIND_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Wind', v, b),
	DAMAGE_PROPERTY_POISON_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Poison', v, b),
	DAMAGE_PROPERTY_SAINT_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Holy', v, b),
	DAMAGE_PROPERTY_DARKNESS_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Dark', v, b),
	DAMAGE_PROPERTY_TELEKINESIS_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Ghost', v, b),
	DAMAGE_PROPERTY_UNDEAD_TARGET: (v, b) => addKeyed('bAddEle', 'Ele_Undead', v, b),

	// Element damage received (physical) — same key as tolerance, stacks
	DAMAGE_PROPERTY_NOTHING_USER: (v, b) => addKeyed('bSubEle', 'Ele_Neutral', v, b),
	DAMAGE_PROPERTY_WATER_USER: (v, b) => addKeyed('bSubEle', 'Ele_Water', v, b),
	DAMAGE_PROPERTY_GROUND_USER: (v, b) => addKeyed('bSubEle', 'Ele_Earth', v, b),
	DAMAGE_PROPERTY_FIRE_USER: (v, b) => addKeyed('bSubEle', 'Ele_Fire', v, b),
	DAMAGE_PROPERTY_WIND_USER: (v, b) => addKeyed('bSubEle', 'Ele_Wind', v, b),
	DAMAGE_PROPERTY_POISON_USER: (v, b) => addKeyed('bSubEle', 'Ele_Poison', v, b),
	DAMAGE_PROPERTY_SAINT_USER: (v, b) => addKeyed('bSubEle', 'Ele_Holy', v, b),
	DAMAGE_PROPERTY_DARKNESS_USER: (v, b) => addKeyed('bSubEle', 'Ele_Dark', v, b),
	DAMAGE_PROPERTY_TELEKINESIS_USER: (v, b) => addKeyed('bSubEle', 'Ele_Ghost', v, b),
	DAMAGE_PROPERTY_UNDEAD_USER: (v, b) => addKeyed('bSubEle', 'Ele_Undead', v, b),

	// Magic element damage dealt
	ADDSKILLMDAMAGE_ALL: (v, b) => addKeyed('bMagicAddEle', 'Ele_All', v, b),
	ADDSKILLMDAMAGE_NOTHING: (v, b) => addKeyed('bMagicAddEle', 'Ele_Neutral', v, b),
	ADDSKILLMDAMAGE_WATER: (v, b) => addKeyed('bMagicAddEle', 'Ele_Water', v, b),
	ADDSKILLMDAMAGE_GROUND: (v, b) => addKeyed('bMagicAddEle', 'Ele_Earth', v, b),
	ADDSKILLMDAMAGE_FIRE: (v, b) => addKeyed('bMagicAddEle', 'Ele_Fire', v, b),
	ADDSKILLMDAMAGE_WIND: (v, b) => addKeyed('bMagicAddEle', 'Ele_Wind', v, b),
	ADDSKILLMDAMAGE_POISON: (v, b) => addKeyed('bMagicAddEle', 'Ele_Poison', v, b),
	ADDSKILLMDAMAGE_SAINT: (v, b) => addKeyed('bMagicAddEle', 'Ele_Holy', v, b),
	ADDSKILLMDAMAGE_DARKNESS: (v, b) => addKeyed('bMagicAddEle', 'Ele_Dark', v, b),
	ADDSKILLMDAMAGE_TELEKINESIS: (v, b) => addKeyed('bMagicAddEle', 'Ele_Ghost', v, b),

	// Magic element damage received
	MDAMAGE_PROPERTY_NOTHING_USER: (v, b) => addKeyed('bSubEle', 'Ele_Neutral', v, b),
	MDAMAGE_PROPERTY_WATER_USER: (v, b) => addKeyed('bSubEle', 'Ele_Water', v, b),
	MDAMAGE_PROPERTY_GROUND_USER: (v, b) => addKeyed('bSubEle', 'Ele_Earth', v, b),
	MDAMAGE_PROPERTY_FIRE_USER: (v, b) => addKeyed('bSubEle', 'Ele_Fire', v, b),
	MDAMAGE_PROPERTY_WIND_USER: (v, b) => addKeyed('bSubEle', 'Ele_Wind', v, b),
	MDAMAGE_PROPERTY_POISON_USER: (v, b) => addKeyed('bSubEle', 'Ele_Poison', v, b),
	MDAMAGE_PROPERTY_SAINT_USER: (v, b) => addKeyed('bSubEle', 'Ele_Holy', v, b),
	MDAMAGE_PROPERTY_DARKNESS_USER: (v, b) => addKeyed('bSubEle', 'Ele_Dark', v, b),
	MDAMAGE_PROPERTY_TELEKINESIS_USER: (v, b) => addKeyed('bSubEle', 'Ele_Ghost', v, b),
	MDAMAGE_PROPERTY_UNDEAD_USER: (v, b) => addKeyed('bSubEle', 'Ele_Undead', v, b),

	// Magic element damage dealt (to target)
	MDAMAGE_PROPERTY_NOTHING_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Neutral', v, b),
	MDAMAGE_PROPERTY_WATER_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Water', v, b),
	MDAMAGE_PROPERTY_GROUND_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Earth', v, b),
	MDAMAGE_PROPERTY_FIRE_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Fire', v, b),
	MDAMAGE_PROPERTY_WIND_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Wind', v, b),
	MDAMAGE_PROPERTY_POISON_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Poison', v, b),
	MDAMAGE_PROPERTY_SAINT_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Holy', v, b),
	MDAMAGE_PROPERTY_DARKNESS_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Dark', v, b),
	MDAMAGE_PROPERTY_TELEKINESIS_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Ghost', v, b),
	MDAMAGE_PROPERTY_UNDEAD_TARGET: (v, b) => addKeyed('bMagicAddEle', 'Ele_Undead', v, b),

	// Magic size damage dealt
	MDAMAGE_SIZE_LARGE_TARGET: (v, b) => addKeyed('bMagicAddSize', 'Size_Large', v, b),
	MDAMAGE_SIZE_MIDIUM_TARGET: (v, b) => addKeyed('bMagicAddSize', 'Size_Medium', v, b),
	MDAMAGE_SIZE_SMALL_TARGET: (v, b) => addKeyed('bMagicAddSize', 'Size_Small', v, b),

	// Magic size damage received
	MDAMAGE_SIZE_LARGE_USER: (v, b) => addKeyed('bMagicSubSize', 'Size_Large', v, b),
	MDAMAGE_SIZE_MIDIUM_USER: (v, b) => addKeyed('bMagicSubSize', 'Size_Medium', v, b),
	MDAMAGE_SIZE_SMALL_USER: (v, b) => addKeyed('bMagicSubSize', 'Size_Small', v, b),

	// Race damage dealt (physical)
	RACE_DAMAGE_NOTHING: (v, b) => addKeyed('bAddRace', 'RC_Formless', v, b),
	RACE_DAMAGE_UNDEAD: (v, b) => addKeyed('bAddRace', 'RC_Undead', v, b),
	RACE_DAMAGE_ANIMAL: (v, b) => addKeyed('bAddRace', 'RC_Brute', v, b),
	RACE_DAMAGE_PLANT: (v, b) => addKeyed('bAddRace', 'RC_Plant', v, b),
	RACE_DAMAGE_INSECT: (v, b) => addKeyed('bAddRace', 'RC_Insect', v, b),
	RACE_DAMAGE_FISHS: (v, b) => addKeyed('bAddRace', 'RC_Fish', v, b),
	RACE_DAMAGE_DEVIL: (v, b) => addKeyed('bAddRace', 'RC_Demon', v, b),
	RACE_DAMAGE_HUMAN: (v, b) => addKeyed('bAddRace', 'RC_DemiHuman', v, b),
	RACE_DAMAGE_ANGEL: (v, b) => addKeyed('bAddRace', 'RC_Angel', v, b),
	RACE_DAMAGE_DRAGON: (v, b) => addKeyed('bAddRace', 'RC_Dragon', v, b),

	// Race tolerance (damage received)
	RACE_TOLERACE_NOTHING: (v, b) => addKeyed('bSubRace', 'RC_Formless', v, b),
	RACE_TOLERACE_UNDEAD: (v, b) => addKeyed('bSubRace', 'RC_Undead', v, b),
	RACE_TOLERACE_ANIMAL: (v, b) => addKeyed('bSubRace', 'RC_Brute', v, b),
	RACE_TOLERACE_PLANT: (v, b) => addKeyed('bSubRace', 'RC_Plant', v, b),
	RACE_TOLERACE_INSECT: (v, b) => addKeyed('bSubRace', 'RC_Insect', v, b),
	RACE_TOLERACE_FISHS: (v, b) => addKeyed('bSubRace', 'RC_Fish', v, b),
	RACE_TOLERACE_DEVIL: (v, b) => addKeyed('bSubRace', 'RC_Demon', v, b),
	RACE_TOLERACE_HUMAN: (v, b) => addKeyed('bSubRace', 'RC_DemiHuman', v, b),
	RACE_TOLERACE_ANGEL: (v, b) => addKeyed('bSubRace', 'RC_Angel', v, b),
	RACE_TOLERACE_DRAGON: (v, b) => addKeyed('bSubRace', 'RC_Dragon', v, b),

	// Race magic damage dealt
	RACE_MDAMAGE_NOTHING: (v, b) => addKeyed('bMagicAddRace', 'RC_Formless', v, b),
	RACE_MDAMAGE_UNDEAD: (v, b) => addKeyed('bMagicAddRace', 'RC_Undead', v, b),
	RACE_MDAMAGE_ANIMAL: (v, b) => addKeyed('bMagicAddRace', 'RC_Brute', v, b),
	RACE_MDAMAGE_PLANT: (v, b) => addKeyed('bMagicAddRace', 'RC_Plant', v, b),
	RACE_MDAMAGE_INSECT: (v, b) => addKeyed('bMagicAddRace', 'RC_Insect', v, b),
	RACE_MDAMAGE_FISHS: (v, b) => addKeyed('bMagicAddRace', 'RC_Fish', v, b),
	RACE_MDAMAGE_DEVIL: (v, b) => addKeyed('bMagicAddRace', 'RC_Demon', v, b),
	RACE_MDAMAGE_HUMAN: (v, b) => addKeyed('bMagicAddRace', 'RC_DemiHuman', v, b),
	RACE_MDAMAGE_ANGEL: (v, b) => addKeyed('bMagicAddRace', 'RC_Angel', v, b),
	RACE_MDAMAGE_DRAGON: (v, b) => addKeyed('bMagicAddRace', 'RC_Dragon', v, b),

	// Race crit rate
	RACE_CRI_PERCENT_NOTHING: (v, b) => addKeyed('bCriticalAddRace', 'RC_Formless', v, b),
	RACE_CRI_PERCENT_UNDEAD: (v, b) => addKeyed('bCriticalAddRace', 'RC_Undead', v, b),
	RACE_CRI_PERCENT_ANIMAL: (v, b) => addKeyed('bCriticalAddRace', 'RC_Brute', v, b),
	RACE_CRI_PERCENT_PLANT: (v, b) => addKeyed('bCriticalAddRace', 'RC_Plant', v, b),
	RACE_CRI_PERCENT_INSECT: (v, b) => addKeyed('bCriticalAddRace', 'RC_Insect', v, b),
	RACE_CRI_PERCENT_FISHS: (v, b) => addKeyed('bCriticalAddRace', 'RC_Fish', v, b),
	RACE_CRI_PERCENT_DEVIL: (v, b) => addKeyed('bCriticalAddRace', 'RC_Demon', v, b),
	RACE_CRI_PERCENT_HUMAN: (v, b) => addKeyed('bCriticalAddRace', 'RC_DemiHuman', v, b),
	RACE_CRI_PERCENT_ANGEL: (v, b) => addKeyed('bCriticalAddRace', 'RC_Angel', v, b),
	RACE_CRI_PERCENT_DRAGON: (v, b) => addKeyed('bCriticalAddRace', 'RC_Dragon', v, b),

	// Race ignore DEF%
	RACE_IGNORE_DEF_PERCENT_NOTHING: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Formless', v, b),
	RACE_IGNORE_DEF_PERCENT_UNDEAD: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Undead', v, b),
	RACE_IGNORE_DEF_PERCENT_ANIMAL: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Brute', v, b),
	RACE_IGNORE_DEF_PERCENT_PLANT: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Plant', v, b),
	RACE_IGNORE_DEF_PERCENT_INSECT: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Insect', v, b),
	RACE_IGNORE_DEF_PERCENT_FISHS: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Fish', v, b),
	RACE_IGNORE_DEF_PERCENT_DEVIL: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Demon', v, b),
	RACE_IGNORE_DEF_PERCENT_HUMAN: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_DemiHuman', v, b),
	RACE_IGNORE_DEF_PERCENT_ANGEL: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Angel', v, b),
	RACE_IGNORE_DEF_PERCENT_DRAGON: (v, b) => addKeyed('bIgnoreDefRaceRate', 'RC_Dragon', v, b),

	// Race ignore MDEF%
	RACE_IGNORE_MDEF_PERCENT_NOTHING: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Formless', v, b),
	RACE_IGNORE_MDEF_PERCENT_UNDEAD: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Undead', v, b),
	RACE_IGNORE_MDEF_PERCENT_ANIMAL: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Brute', v, b),
	RACE_IGNORE_MDEF_PERCENT_PLANT: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Plant', v, b),
	RACE_IGNORE_MDEF_PERCENT_INSECT: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Insect', v, b),
	RACE_IGNORE_MDEF_PERCENT_FISHS: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Fish', v, b),
	RACE_IGNORE_MDEF_PERCENT_DEVIL: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Demon', v, b),
	RACE_IGNORE_MDEF_PERCENT_HUMAN: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_DemiHuman', v, b),
	RACE_IGNORE_MDEF_PERCENT_ANGEL: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Angel', v, b),
	RACE_IGNORE_MDEF_PERCENT_DRAGON: (v, b) => addKeyed('bIgnoreMdefRaceRate', 'RC_Dragon', v, b),

	// Class damage dealt
	CLASS_DAMAGE_BOSS_TARGET: (v, b) => addKeyed('bAddClass', 'Class_Boss', v, b),
	CLASS_DAMAGE_NORMAL_TARGET: (v, b) => addKeyed('bAddClass', 'Class_Normal', v, b),

	// Class damage received
	CLASS_DAMAGE_BOSS_USER: (v, b) => addKeyed('bSubClass', 'Class_Boss', v, b),
	CLASS_DAMAGE_NORMAL_USER: (v, b) => addKeyed('bSubClass', 'Class_Normal', v, b),

	// Class ignore DEF / MDEF
	CLASS_IGNORE_DEF_PERCENT_BOSS: (v, b) => addKeyed('bIgnoreDefClassRate', 'Class_Boss', v, b),
	CLASS_IGNORE_DEF_PERCENT_NORMAL: (v, b) => addKeyed('bIgnoreDefClassRate', 'Class_Normal', v, b),
	CLASS_IGNORE_MDEF_PERCENT_BOSS: (v, b) => addKeyed('bIgnoreMdefClassRate', 'Class_Boss', v, b),
	CLASS_IGNORE_MDEF_PERCENT_NORMAL: (v, b) => addKeyed('bIgnoreMdefClassRate', 'Class_Normal', v, b),

	// Class magic damage
	CLASS_MDAMAGE_BOSS: (v, b) => addKeyed('bMagicAddClass', 'Class_Boss', v, b),
	CLASS_MDAMAGE_NORMAL: (v, b) => addKeyed('bMagicAddClass', 'Class_Normal', v, b),

	// EXP bonuses
	ADDEXPPERCENT_KILLRACE_NOTHING: (v, b) => addKeyed('bExpAddRace', 'RC_Formless', v, b),
	ADDEXPPERCENT_KILLRACE_UNDEAD: (v, b) => addKeyed('bExpAddRace', 'RC_Undead', v, b),
	ADDEXPPERCENT_KILLRACE_ANIMAL: (v, b) => addKeyed('bExpAddRace', 'RC_Brute', v, b),
	ADDEXPPERCENT_KILLRACE_PLANT: (v, b) => addKeyed('bExpAddRace', 'RC_Plant', v, b),
	ADDEXPPERCENT_KILLRACE_INSECT: (v, b) => addKeyed('bExpAddRace', 'RC_Insect', v, b),
	ADDEXPPERCENT_KILLRACE_FISHS: (v, b) => addKeyed('bExpAddRace', 'RC_Fish', v, b),
	ADDEXPPERCENT_KILLRACE_DEVIL: (v, b) => addKeyed('bExpAddRace', 'RC_Demon', v, b),
	ADDEXPPERCENT_KILLRACE_HUMAN: (v, b) => addKeyed('bExpAddRace', 'RC_DemiHuman', v, b),
	ADDEXPPERCENT_KILLRACE_ANGEL: (v, b) => addKeyed('bExpAddRace', 'RC_Angel', v, b),
	ADDEXPPERCENT_KILLRACE_DRAGON: (v, b) => addKeyed('bExpAddRace', 'RC_Dragon', v, b),
	ADDEXPPERCENT_KILLRACE_ALL: (v, b) => addKeyed('bExpAddRace', 'RC_All', v, b),

	// Indestructible — no bonus effect in the simulator
	WEAPON_INDESTRUCTIBLE: () => {},
	BODY_INDESTRUCTIBLE: () => {},
}

export function applyItemOptions(options, bonuses) {
	if (!options) return
	options.forEach(({ optionId, value }) => {
		if (!optionId || !value) return
		const handler = OPTION_BONUS_MAP[optionId]
		if (handler) handler(value, bonuses)
	})
}
